import {
  MedicalAttestationSending,
  ValidateMedicalAttestationInput
} from '../../lib/types/models/medical-attestation-sending/medical-attestation-sending'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function validateMedicalStatement({
  id,
  ...data
}: IdInput<ValidateMedicalAttestationInput>) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.validateMedicalAttestation.url, { id }))
    .post<MedicalAttestationSending, ValidateMedicalAttestationInput>(data)
}
